import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, MapPin } from "lucide-react";
import { EVENT_CAT, eventCredit, eventImage, fmt, fmtRange, isSponsored } from "@/lib/meta";
import { PhotoCredit } from "@/components/PhotoCredit";
import { FavoriteButton } from "@/components/FavoriteButton";

export const DateBlock = ({ start, dark }) => (
  <div className={`flex w-16 shrink-0 flex-col items-center justify-center border py-2 ${dark ? "border-white/20" : "border-foreground/15 bg-white/50"}`}>
    <span className="eyebrow !text-[0.6rem]">{fmt(start, "EEE")}</span>
    <span className="font-display text-3xl leading-none">{fmt(start, "d")}</span>
    <span className="font-sub text-xs uppercase">{fmt(start, "MMM")}</span>
  </div>
);

export const SampleBadge = () => (
  <span className="eyebrow border border-foreground/20 px-1.5 py-0.5 !text-[0.6rem] text-muted-foreground" title="Kuratierte Beispieldaten">
    Beispiel
  </span>
);

export const EventRow = ({ ev, day }) => (
  <Link to={`/veranstaltungen/${ev.id}`} data-testid={day ? `event-row-${ev.id}-${day}` : `event-row-${ev.id}`}
    className="group relative grid grid-cols-[auto_1fr] items-center gap-5 border-b border-foreground/10 py-5 pr-12 transition-colors duration-200 hover:bg-white/60 md:grid-cols-[auto_1fr_160px] md:px-3 md:pr-3">
    <FavoriteButton id={ev.id} className="absolute right-0 top-4 !px-2 !py-1.5 md:right-[184px] md:top-1/2 md:-translate-y-1/2" />
    <DateBlock start={day || ev.start} />
    <div className="min-w-0 md:pr-12">
      <div className="flex flex-wrap items-center gap-2">
        <span className="eyebrow text-terracotta">{EVENT_CAT[ev.category]?.label}</span>
        {ev.sample && <SampleBadge />}
        {isSponsored(ev) && <span className="eyebrow border border-foreground/30 px-1.5 py-0.5 !text-[0.6rem]" data-testid={`event-row-ad-${ev.id}`}>Anzeige</span>}
      </div>
      <h3 className="mt-1 font-sub text-lg font-medium leading-snug group-hover:text-terracotta transition-colors">{ev.title}</h3>
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground">
        <span className="flex items-center gap-1.5"><Clock size={14} strokeWidth={1.5} />{fmtRange(ev)}</span>
        <span className="flex items-center gap-1.5"><MapPin size={14} strokeWidth={1.5} />{ev.region}</span>
      </div>
    </div>
    <div className="hidden md:block">
      <div className="no-photo relative h-24 overflow-hidden">
        {eventImage(ev) && <img src={eventImage(ev, 400)} alt="" loading="lazy" className="img-tint h-full w-full object-cover" />}
        <ArrowUpRight className="absolute right-2 top-2 text-white opacity-0 transition-opacity group-hover:opacity-100" size={18} />
      </div>
      <PhotoCredit credit={eventCredit(ev)} inLink className="mt-1" testid={`event-row-credit-${ev.id}`} />
    </div>
  </Link>
);
